module.exports = __webpack_public_path__ + "r-v3/img/excel.44930832.svg";